<template lang="pug">
div( v-if="listBlocks && listBlocks.length" )
  div.container-list.qwe
    div.dsp-flex( v-for="block in listBlocks" ) 
      div.container-block
        div.task-title
          span.text-14 {{ block.title }}
          span.text-16.price + {{ block.price }} {{ convertToValueLabel('RUR')}}
        div.task-status( :class="{'status-completed' : block.status === 'completed', 'status-check' : block.status === 'in progress'}" )
          span.text-12.status-text {{ returnTaskStatus(block.status) }}
</template>

<script>

export default {
  name: "ScrollListOfTasks",
  props: {
    listBlocks: Array
  },

  methods: {
    returnTaskStatus(status) {
      switch(status) {
        case "completed":
          return "Выполнено"
        case "in progress":
          return "Проверяется"
        default:
          return ""
      }
    }
  }
}
</script>

<style scoped>
.container-list {
  overflow-x: scroll;
  display: -webkit-box;
  width: 100%;
  min-height: 100px;
  height: auto;
  overflow: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;
}
.container-list::-webkit-scrollbar {
  width: 0px;
  background-color: transparent;
}
.container-block {
  margin-right: 8px;
  background: #FFFF;
  width: 186px;
  height: 76px;
  border-radius: 16px;
  box-shadow: 0px 8px 15px 0px #0000001A;
  box-shadow: 0px 2px 6px 0px #0000001A;
  padding: 13px 10px 12px 12px;
}
.task-title {
  display: flex;
  flex-direction: row;
  align-items: baseline;
}
.qwe {
  padding: 5px 0 8px 8px;
}
.price {
  margin-left: auto;
  color: #FF9900;
}
.task-status {
  margin-top: 7px;
  width: 90px;
  height: 24px;
  border-radius: 9999px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.status-completed {
  background: #A3D977;
  color: #FFFFFF
}
.status-check {
  background: #FDCB46;
  color: #171D33;
}
</style>